// extracted by mini-css-extract-plugin
export default {"container":"PartnerForm_container__-CkM2","form":"PartnerForm_form__tDetr"};